import { useEffect, useState } from 'react';
import Autocomplete from "react-google-autocomplete";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { setPlace } from '../../../Redux/Action/Action';
import { useForm } from 'react-hook-form';
import DataLoader from '../../../Utils/DataLoader';
import TravelPreferencesResult from '../travelPreferences/TravelPreferencesResult';
import logogift from '../../../assets/images/gift.png'
import slider1 from '../../../assets/images/slider1.jpg'
import slider2 from '../../../assets/images/slider2.png'
import slider3 from '../../../assets/images/slider3.png'
import slider4 from '../../../assets/images/slider4.png'
import roundedshape from '../../../assets/images/rounded-shape.svg'
import search from '../../../assets/images/search.svg'
import calendar from '../../../assets/images/calendar.svg'
import Global from '../../../assets/images/Global.svg'
import people from '../../../assets/images/people.svg'

export default function TopBannerForm() {

    const place = useSelector((state) => state.place);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [activeTab, setActiveTab] = useState("hotel");
    const [pageLoading, setPageLoading] = useState(true);

    const [tripData, setTripData] = useState({});
    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);

    const today = new Date().toISOString().split("T")[0];
    const maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() + 2);
    const maxAllowedDate = maxDate.toISOString().split("T")[0];
    const localSelectedCity = localStorage.getItem('selectedCity');

    const {
        register,
        handleSubmit,
        reset,
        setValue,
        trigger,
        formState: { errors },
    } = useForm();



    /* ============================================================
       🎯 YOUR STREAMING API (INSIDE SAME COMPONENT)
    ============================================================ */
    const handleFormSubmit = async (data) => {
        setFormData(data);
        setLoading(true);
        setTripData({});

        try {
            const response = await fetch(
                "https://mysittivacations.kindlebit.com/generate-itinerary/stream",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(data),
                }
            );

            if (!response.ok) throw new Error("Network response was not ok");

            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = "";
            let partialTripData = {
                gettingThere: { content: "" },
                days: [],
                overview: { content: "" }
            };
            let currentSection = null;

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                const chunk = decoder.decode(value, { stream: true });
                buffer += chunk;

                const lines = buffer.split("\n");

                for (let i = 0; i < lines.length - 1; i++) {
                    const line = lines[i].trim();
                    if (line.startsWith("data:")) {
                        const jsonStr = line.replace(/^data:\s*/, "");
                        try {
                            const jsonChunk = JSON.parse(jsonStr);
                            const content = jsonChunk.content;

                            if (content.gettingThere?.content) {
                                if (currentSection !== "gettingThere") {
                                    currentSection = "gettingThere";
                                    partialTripData.gettingThere.content = "";
                                }
                                partialTripData.gettingThere.content += content.gettingThere.content;
                            }

                            if (content.days && Array.isArray(content.days)) {
                                partialTripData.days = content.days;
                            }

                            if (content.overview?.content) {
                                if (currentSection !== "overview") {
                                    currentSection = "overview";
                                    partialTripData.overview.content = "";
                                }
                                partialTripData.overview.content += content.overview.content;
                            }

                            setTripData({ ...partialTripData });

                        } catch (e) {
                            console.warn("Invalid JSON chunk:", line);
                        }
                    }
                }
                buffer = lines[lines.length - 1];
            }

            setIsSubmitted(true);
        } catch (err) {
            console.error("Error fetching itinerary:", err);
            setToastMessage("Failed to fetch itinerary. Please try again!");
            setShowToast(true);
        } finally {
            setLoading(false);
        }
    };

    /* ============================================================
       🎯 MAP PAYLOADS PER TAB
    ============================================================ */

    const mapFlightData = (data) => ({
        from: data?.destination,
        startDate: data?.startDate,
        endDate: data?.endDate,
        members: data?.members,
    });

    const mapHotelData = (data) => ({
        destination: data?.destination,
        checkIn: data?.startDate,
        checkOut: data?.endDate,
        members: data?.members,
        rooms: data?.rooms,
    });

    /* ============================================================
       🎯 ROUTE SUBMIT BASED ON TAB
    ============================================================ */
    const handleFlightSubmit = (data) => handleFormSubmit(mapFlightData(data));
    const handleHotelSubmit = (data) => handleFormSubmit(mapHotelData(data));

    const onSubmit = (data) => {
        if (activeTab === "flight") return handleFlightSubmit(data);
        if (activeTab === "hotel") return handleHotelSubmit(data);
    };

    useEffect(() => {
        async function loadAllData() {
            try {
                await Promise.all([

                ]);
            } catch (err) {
                console.log("Page loading error:", err);
            } finally {
                setPageLoading(false);
            }
        }

        loadAllData();
    }, []);

    if (pageLoading || loading) {
        return <DataLoader />;  // Full screen loader
    }


    if (isSubmitted) {
        return (
            <TravelPreferencesResult
                formData={formData}
                tripData={tripData}
                onBack={() => {
                    reset()
                    setIsSubmitted(false);
                    setTripData({});
                }}
            />
        );
    }
    return (
        <section className="slider-section">


            <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel" data-bs-interval="2000">
                <div className="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
                    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="3" aria-label="Slide 4"></button>
                </div>
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img src={slider1} className="w-100 slider-reverse-img" alt="..." />
                    </div>
                    <div className="carousel-item">
                        <img src={slider2} className="w-100 slider-reverse-img" alt="..." />
                    </div>
                    <div className="carousel-item">
                        <img src={slider3} className="w-100 slider-reverse-img" alt="..." />
                    </div>
                    <div className="carousel-item">
                        <img src={slider4} className="w-100 slider-reverse-img" alt="..." />
                    </div>
                </div>
            </div>


            <div className="slider-shape">
                <img className="right-side slider-reverse-img" src={roundedshape} />
                <img className="left-side" src={roundedshape} />
            </div>


            <div className="slider-shape bottom">
                <img className="right-side slider-reverse-img" src={roundedshape} />
                <img className="left-side" src={roundedshape} />
            </div>


            <div className="slider-caption-section">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6 align-self-center" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                            <div className="slider-content">
                                <h1>Refreshing exploration of the world</h1>
                                <h2>Your Dream Trip Awaits!</h2>
                                <p>Thinking of escaping the daily grind? Relax, we’ve got your dream trip covered!</p>
                            </div>

                            <div className="hero-search-form mt-2 mt-md-4 ">
                                <form>
                                    <div className="form-group position-relative">
                                        <Autocomplete
                                            className="form-control"
                                            apiKey="AIzaSyDrSVPFOzjxmlv2WLSnfJ0ARrmYP9QDajs"
                                            placeholder={
                                                localSelectedCity && localSelectedCity !== "undefined" && place
                                                    ? place.replace(/\b\w/g, (x) => x.toUpperCase())
                                                    : "Where would you like to go"
                                            }
                                            onPlaceSelected={async (city) => {
                                                const selectedCity = city.formatted_address.split(",")[0].toLowerCase();
                                                // Update route
                                                await navigate(`/experiences/${selectedCity}`);
                                                setValue("destination", city, { shouldValidate: true });
                                                trigger("destination");


                                                // Dispatch Redux actions
                                                dispatch(setPlace(selectedCity));
                                                localStorage.setItem('selectedCity', city.formatted_address.split(',')[0]);
                                            }}
                                        />
                                        <button className="search-btn" type="button"><img src={search} alt='search' /></button>
                                    </div>
                                </form>
                            </div>

                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                            <div className="booking-form">
                                {/* ===== TABS ===== */}
                                <ul className="nav nav-pills mb-4">
                                    {["hotel", "flight"].map((tab) => (
                                        <li key={tab} className="nav-item">
                                            <button
                                                type="button"
                                                className={`nav-link ${activeTab === tab ? "active" : ""
                                                    }`}
                                                onClick={() => setActiveTab(tab)}
                                            >
                                                {tab.charAt(0).toUpperCase() + tab.slice(1)}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                                <div className="tab-content" id="pills-tabContent">
                                    <div
                                        className="tab-pane fade show active"
                                        id="pills-home"
                                        role="tabpanel"
                                        aria-labelledby="pills-home-tab"
                                        tabIndex="0"
                                    >
                                        <div className="booking-form-group">
                                            <form onSubmit={handleSubmit(onSubmit)}>

                                                {/* DESTINATION / FROM */}
                                                <div className="form-group mb-4">
                                                    <label className="form-group-label">
                                                        {activeTab === "flight" ? "From" : "Destination"}
                                                    </label>

                                                    <div className="position-relative">
                                                        <Autocomplete
                                                            className="form-control"
                                                            apiKey="AIzaSyDrSVPFOzjxmlv2WLSnfJ0ARrmYP9QDajs"
                                                            placeholder={
                                                                localSelectedCity && localSelectedCity !== "undefined" && place
                                                                    ? place.replace(/\b\w/g, (x) => x.toUpperCase())
                                                                    : "Where would you like to go"
                                                            }

                                                            onPlaceSelected={async (city) => {
                                                                const selectedCity = city.formatted_address.split(",")[0].toLowerCase();
                                                                // Update route
                                                                if (!city) return;
                                                                const cityName = city.formatted_address.split(",")[0];
                                                                setValue("destination", cityName, { shouldValidate: true });
                                                                trigger("destination");

                                                                // Dispatch Redux actions
                                                                // dispatch(setPlace(selectedCity));
                                                                // localStorage.setItem('selectedCity', city.formatted_address.split(',')[0]);
                                                            }}
                                                        />
                                                        <input
                                                            type="hidden"
                                                            {...register("destination", { required: "Destination is required" })}
                                                        />

                                                        <img
                                                            className="form-icon-left"
                                                            src={Global} alt='global'
                                                        />

                                                    </div>
                                                    {errors.destination && (
                                                        <small className="text-danger">
                                                            {errors.destination.message}
                                                        </small>
                                                    )}
                                                </div>


                                                <div className="form-group mb-4">
                                                    <label className="form-group-label">Date</label>

                                                    <div className="row g-2">
                                                        <div className="col-6">
                                                            <div className='position-relative'>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    {...register("startDate", {
                                                                        required: "Start date is required",
                                                                    })}
                                                                />
                                                                <img
                                                                    className="form-icon-left"
                                                                    src={calendar}
                                                                    alt='calendar'
                                                                />
                                                            </div>
                                                            {errors.startDate && (
                                                                <small className="text-danger">
                                                                    {errors.startDate.message}
                                                                </small>
                                                            )}
                                                        </div>

                                                        <div className="col-6">
                                                            <div className='position-relative'>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    {...register("endDate", {
                                                                        required:
                                                                            activeTab !== "flight" ? "End date is required" : false,
                                                                    })}
                                                                />
                                                                <img
                                                                    className="form-icon-left"
                                                                    src={calendar}
                                                                    alt='calendar'
                                                                />
                                                            </div>
                                                            {errors.endDate && (
                                                                <small className="text-danger">
                                                                    {errors.endDate.message}
                                                                </small>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>


                                                {/* PEOPLE */}
                                                <div className="form-group mb-4">
                                                    <label className="form-group-label">Members</label>

                                                    <div className="position-relative">
                                                        <input
                                                            type="number"
                                                            className="form-control mt-2"
                                                            placeholder="Enter No. of Members"
                                                            {...register("members", {
                                                                required: "Please enter number of members",
                                                                min: { value: 1, message: "Minimum 1 person required" },
                                                                validate: (value) =>
                                                                    Number.isInteger(Number(value)) ||
                                                                    "Must be a valid number",
                                                            })}
                                                        />

                                                        <img
                                                            className="form-icon-left"
                                                            src={people} alt='people'
                                                        />
                                                    </div>

                                                    {errors.members && (
                                                        <small className="text-danger">
                                                            {errors.members.message}
                                                        </small>
                                                    )}
                                                </div>


                                                {/* HOTEL EXTRA FIELD */}
                                                {activeTab === "hotel" && (
                                                    <div className="form-group mb-4">
                                                        <label className="form-group-label">Rooms</label>

                                                        <div className="position-relative">
                                                            <input
                                                                type='number'
                                                                placeholder='Enter No. of Rooms'
                                                                className="form-control"
                                                                {...register("rooms", {
                                                                    required: "Please select rooms",
                                                                    validate: (value) =>
                                                                        Number.isInteger(Number(value)) ||
                                                                        "Must be a valid number",
                                                                })}
                                                            />


                                                            <img
                                                                className="form-icon-left"
                                                                src={Global}
                                                                alt='global'
                                                            />
                                                        </div>


                                                        {errors.rooms && (
                                                            <small className="text-danger">
                                                                {errors.rooms.message}
                                                            </small>
                                                        )}
                                                    </div>
                                                )}

                                                {/* SUBMIT */}
                                                <div className="form-group-submit">
                                                    <button type="submit" className="submit-btn">
                                                        Explore {activeTab}
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <Link to={place && localSelectedCity && localSelectedCity !== "undefined" ? `/travelpreferences/${place}` : `/travelpreferences`}>
                    <button type="button" className="gift_btn">
                        <span>
                            <img src={logogift} alt="" />
                        </span>
                        <p>Get My Free Travel Guide</p>

                    </button>
                </Link>
            </div>

        </section>
    )
}
